export const original_index = state=>state.original_index 
export const CATE_LIST = state =>state.cate_list
export const ACTIVITY_LIST = state =>state.activity_list


// WEBPACK FOOTER //
// ./src/store/getters.js